// The one place the renderer reaches FormHelper (the generated copy of the server's rules, ../../form-helper).
// The path is relative on purpose: the renderer's logic and fields are tested with `node --test`, where the `@core`
// alias does not exist. Everything else in this folder imports FormHelper from here.
export * from "../../form-helper/index.js";
